import axios from 'axios';
import * as Config from '../../config';

const state = {};

const actions = {
    notificacion_store({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'notificacion/store', form, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    notificacion_store2({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'notificacion/store-2', form, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    notificacion_get({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'notificacion/get/' + form.id)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    notificacion_get_unread({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'notificacion/get-unread/' + form.id)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    notificacion_get_file({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'notificacion/get-file/' + form.path, {
                    responseType: 'blob' // Indicamos que esperamos una respuesta binaria
                })
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    notificacion_store_update_token_push({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'notificacion/store-update-token-push', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    notificacion_enviar_notificacion_push({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'notificacion/enviar-notificacion-push', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    }
}

const mutations = {

};

export default {
    state,
    actions,
    mutations
};